<template>
    <form @submit.prevent="submit" ref="form" autocomplete="off" :method="method">
        <slot :errors="errors" :saving="saving" />
    </form>
</template>

<script>
import Errors from '~/models/errors.js'

export default {
    name: 'InputForm',

    props: {
        action: String,
        method: {
            type: String,
            default: 'POST',
        },
        submitable: {
            type: Boolean,
            default: true,
        },
        files: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            errors: new Errors(),
            saving: false,
        }
    },

    methods: {
        submit(e = null) {
            if (this.saving) {
                return
            }

            this.saving = true

            if (e != null) {
                e.preventDefault()
            }

            this.$emit('onSubmitStarted')
            this.errors = new Errors()

            let data = new FormData(this.$refs.form)

            if (e != null && e.submitter != null && e.submitter.name != null) {
                data.append(e.submitter.name, e.submitter.value)
            }

            if (this.action == null) {
                this.$emit('onSubmit', data)
                return
            }

            this.errors = new Errors()

            let headers = this.files ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}

            this.$axios
                .post(this.action, data, headers)
                .then((res) => {
                    setTimeout(() => {
                        this.saving = false
                        this.$emit('onSubmitted', res, e)
                    }, this.$help.globalSubmitDelay())
                })
                .catch((error) => {
                    setTimeout(() => {
                        this.setErrors(error)
                        this.saving = false
                        this.$emit('onError', error.data)
                    }, this.$help.globalSubmitDelay())
                })
        },

        clear(full = false) {
            this.errors = new Errors()
        },

        setErrors(error) {
            // console.log(error)
            this.errors = new Errors(error.data.errors)

            this.$nextTick(() => {
                let errors = document.getElementsByClassName('error')

                if (errors.length == 0) {
                    return
                }

                let items = document.getElementsByTagName('form')[0].getElementsByClassName('error')
                items = [...items].filter((el) => {
                    return !el.classList.contains('opacity-0') && el.innerText != 'false'
                })

                const visible = [...items].filter((el) => {
                    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
                })

                if (visible.length > 0) {
                    let element = items[0]

                    // console.log(element)

                    if (element.dataset.errorScrollTo != false && document.getElementById(element.dataset.errorScrollTo) != null) {
                        element = document.getElementById(element.dataset.errorScrollTo)
                    }
                    // console.log(element)

                    // console.log(element.getClientRects())
                    // console.dir(element)

                    window.scrollTo({
                        top: element.offsetTop,
                        behavior: 'smooth',
                    })
                }
            })
        },
    },
}
</script>
